import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-681c54e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crowd-funding-page" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 1,
  class: "page-state",
  role: "status"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("加载中…")
const _hoisted_5 = {
  key: 2,
  class: "page-state",
  role: "alert"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重试")
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "card" }
const _hoisted_10 = {
  key: 0,
  class: "price"
}
const _hoisted_11 = {
  key: 0,
  class: "official"
}
const _hoisted_12 = {
  key: 1,
  class: "tags"
}
const _hoisted_13 = {
  key: 2,
  class: "description"
}
const _hoisted_14 = {
  key: 1,
  class: "card"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "规格信息", -1))
const _hoisted_16 = {
  id: "crowd-funding-skus",
  class: "sku-list"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "sku-content" }
const _hoisted_19 = { class: "sku-name" }
const _hoisted_20 = {
  key: 0,
  class: "sku-specs"
}
const _hoisted_21 = { class: "sku-price" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["aria-expanded"]
const _hoisted_24 = {
  key: 2,
  class: "card seller"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 3,
  class: "card"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "预售与履约", -1))
const _hoisted_28 = {
  key: 0,
  class: "description"
}
const _hoisted_29 = {
  key: 1,
  class: "tags"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "services-title" }, "服务保障", -1))
const _hoisted_31 = { class: "tags" }
const _hoisted_32 = {
  key: 4,
  class: "card detail"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "商品详情", -1))
const _hoisted_34 = {
  key: 0,
  class: "description"
}
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = {
  key: 4,
  class: "purchase-bar"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 打开临界 App 购买 ")

import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { Button, Loading, Swipe, SwipeItem } from "vant";
import DownloadBanner from "@/components/DownloadBanner/index.vue";
import { useTitle } from "@/hooks/useTitle";
import { isLinjieApp } from "@/utils/env-related";
import { invokeAppByYYB } from "@/utils/mob";
import { crowdFundingAppTarget, resolveShelfId } from "./utils";
import { usePreview } from "./usePreview";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const isApp = isLinjieApp();
const shelfId = computed(() => resolveShelfId(route.query));
const { preview, loading, error, refresh } = usePreview(shelfId);
const { setTitle } = useTitle();
const expanded = ref(false);
const visibleSkus = computed(() => {
  const skus = preview.value?.skus || [];
  return expanded.value ? skus : skus.slice(0, 4);
});
const officialLabel = computed(() => {
  const verification = preview.value?.officialVerification;
  return verification === "PLATFORM_OWNED"
    ? "自营"
    : verification === "BRAND_OWNED"
    ? "官方"
    : "";
});
const showFulfillment = computed(() => {
  const value = preview.value;
  return (
    value &&
    (value.presellText || value.deliveryMethods.length || value.services.length)
  );
});

watch(
  preview,
  (value) => {
    expanded.value = false;
    setTitle(value?.title ? `${value.title}｜临界` : "众筹详情｜临界");
  },
  { immediate: true }
);

function openApp() {
  if (shelfId.value) invokeAppByYYB(crowdFundingAppTarget(shelfId.value));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isApp))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "download-banner",
          "aria-label": "打开或下载临界 App",
          disabled: !_unref(shelfId),
          onClick: openApp
        }, [
          _createVNode(DownloadBanner)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Loading), {
            color: "#7247dc",
            vertical: ""
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]))
      : (_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(_unref(error)), 1),
            (_unref(shelfId))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  size: "small",
                  onClick: _unref(refresh)
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : (_unref(preview))
          ? (_openBlock(), _createElementBlock("main", _hoisted_7, [
              (_unref(preview).coverImages.length)
                ? (_openBlock(), _createBlock(_unref(Swipe), {
                    key: _unref(shelfId),
                    loop: false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(preview).coverImages, (url, index) => {
                        return (_openBlock(), _createBlock(_unref(SwipeItem), { key: index }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: url,
                              alt: `${_unref(preview).title} 图片 ${index + 1}`,
                              class: "cover"
                            }, null, 8, _hoisted_8)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_9, [
                (_unref(preview).price !== undefined)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, " ¥" + _toDisplayString(_unref(preview).price), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("h1", null, [
                  (_unref(officialLabel))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(officialLabel)), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_unref(preview).title), 1)
                ]),
                (_unref(preview).shelfTags.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(preview).shelfTags, (tag) => {
                        return (_openBlock(), _createElementBlock("span", { key: tag }, _toDisplayString(tag), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(preview).description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(preview).description), 1))
                  : _createCommentVNode("", true)
              ]),
              (_unref(preview).skus.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleSkus), (sku) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: sku.id,
                          type: "button",
                          class: _normalizeClass(["sku", { 'sku-sold-out': sku.isSoldOut }]),
                          onClick: openApp
                        }, [
                          (sku.cover)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: sku.cover,
                                alt: ""
                              }, null, 8, _hoisted_17))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(sku.name), 1),
                            (sku.specLabels.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(sku.specLabels.join(" · ")), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_21, [
                              _createTextVNode(_toDisplayString(sku.price === undefined ? "价格待定" : `¥${sku.price}`) + " ", 1),
                              (sku.isSoldOut)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, " · 已售罄"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 2))
                      }), 128))
                    ]),
                    (_unref(preview).skus.length > 4)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "expand-button",
                          "aria-expanded": expanded.value,
                          "aria-controls": "crowd-funding-skus",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
                        }, _toDisplayString(expanded.value ? "收起" : `展开全部 ${_unref(preview).skus.length}`), 9, _hoisted_23))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(preview).seller)
                ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                    (_unref(preview).seller.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(preview).seller.avatar,
                          alt: ""
                        }, null, 8, _hoisted_25))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_unref(preview).seller.name), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(showFulfillment))
                ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
                    (_unref(preview).presellText || _unref(preview).deliveryMethods.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_27,
                          (_unref(preview).presellText)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_unref(preview).presellText), 1))
                            : _createCommentVNode("", true),
                          (_unref(preview).deliveryMethods.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(preview).deliveryMethods, (method) => {
                                  return (_openBlock(), _createElementBlock("span", { key: method }, _toDisplayString(method), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_unref(preview).services.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(preview).services, (service) => {
                              return (_openBlock(), _createElementBlock("span", { key: service }, _toDisplayString(service), 1))
                            }), 128))
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(preview).detailText || _unref(preview).detailImages.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                    _hoisted_33,
                    (_unref(preview).detailText)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_unref(preview).detailText), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(preview).detailImages, (url, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: index,
                        src: url,
                        alt: `商品详情图片 ${index + 1}`,
                        loading: "lazy"
                      }, null, 8, _hoisted_35))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
    (_unref(preview) && !_unref(loading) && !_unref(error))
      ? (_openBlock(), _createElementBlock("footer", _hoisted_36, [
          _createVNode(_unref(Button), {
            block: "",
            color: "linear-gradient(151deg, #2b1ac0 0%, #7247dc 100%)",
            onClick: openApp
          }, {
            default: _withCtx(() => [
              _hoisted_37
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})